/* eslint-disable unicorn/no-await-expression-member */
import {
  EmptyStateError,
  EmptyStateLoading,
  lazyLoad,
} from 'src/core/common/components/LazyLoad';

export const CardsOrderContainer = lazyLoad({
  loader: async () => ({
    default: (
      await import(
        /* webpackChunkName: "CardsOrderContainer" */ './components/CardsOrderContainer'
      )
    ).CardsOrderContainer,
  }),
  loading: <EmptyStateLoading />,
  fallback: (props) => <EmptyStateError {...props} />,
});
